import {
  Grid,
  Typography,
  Dialog,
  DialogContent,
  DialogContentText,
  DialogTitle,
  DialogActions,
} from "@material-ui/core";
import Button from "@mui/material/Button";
import React from "react";
import LoadingButton from "@mui/lab/LoadingButton";
import SaveIcon from "@mui/icons-material/Save";

export interface IDialogAlerteProps {
  title?: string;
  dialogContent: any;
  open: boolean;
  handleClose?: any;
  actionFunction?: any;
  addLoading?: boolean;
  iconeSauveButton: any;
  actionLabel?: string;
  cancelLabel?: string;
}

export default function ConfirmAction(props: IDialogAlerteProps) {
  const {
    dialogContent,
    open,
    handleClose,
    actionFunction,
    addLoading,
    title,
    iconeSauveButton,
    actionLabel,
    cancelLabel
  } = props;

  return (
    <Dialog maxWidth="xs" fullWidth={true} open={open}>
      <DialogTitle id="alert-dialog-title">
        {title ? title : "Alerte!"}
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          {dialogContent}
        </DialogContentText>
      </DialogContent>
      <DialogActions style={{ marginRight: 15, marginBottom: 10 }}>
        <Button color="error" onClick={handleClose}>
          {cancelLabel ? cancelLabel : "Annuler"}
        </Button>

        <LoadingButton
          loadingPosition="end"
          loading={addLoading}
          endIcon={iconeSauveButton}
          size="small"
          variant="contained"
          onClick={actionFunction}
        >
          {actionLabel}
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
}
